import React from 'react';

export interface ErrorFeedbackProps {}

const ErrorFeedback: React.FC<ErrorFeedbackProps> = ({ children }) => {
   return <div className='invalid-field text-left ml-2 font-weight-medium'>{children}</div>;
};

export default ErrorFeedback;
